export default "__VITE_ASSET__9f8af53f__"